import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { AppConfig } from '../app.config';
import { CustomHttpParamsEncoder } from './settings/CustomHttpParamsEncoder';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GeocodingService {

  constructor(
    private http: HttpClient,
    private config: AppConfig,
    public translater: TranslateService
  ) {
  }

  getPhotonLangQueryParamValue() {
    const browserLang = this.translater.currentLang;
    // if (browserLang == 'NLD' || browserLang == 'nl' || browserLang == 'nl-be') {
    //   return 'nl'
    // } else {
    //   return 'en'
    // }
  const supportedLanguages = JSON.parse(environment.supportedLanguages);
  const matchedLang = supportedLanguages.find(lang => 
    lang.langJson === browserLang || lang.lang === browserLang
  );
  return matchedLang ? matchedLang.lang.toLowerCase() : 'en';
  }

  /**
   * This API call returns the location (and possibly the bounding box) of the specified address. This method returns null if the address cannot be geocoded.
   * @param lat
   * @param lng
   */
  findAddress(lat: number, lng: number): Observable<any> {
    const params = new HttpParams().append('lat', lat.toString()).append('lon', lng.toString());
    return this.http.get(this.config.getEndpoint('geocoding/reverse'), { params });
  }

  /**
   * This API call returns the location of the specified address. This method returns null if the geoding fails.
   * @param address
   */
  findPosition(address: string): Observable<any> {
    const params = new HttpParams({ encoder: new CustomHttpParamsEncoder() }).append('address', address);
    return this.http.get(this.config.getEndpoint('geocoding/geocode_string'), { params });
  }

  getAddressAutocompleteParams(q?: string, lat?: number, lng?: number) {
    const params = {};

    if (q) {
      params['q'] = q;
    }
    if (lat) {
      params['lat'] = lat.toString();
    }
    if (lng) {
      params['lon'] = lng.toString();
    }

    params['lang'] = this.getPhotonLangQueryParamValue();
    params['limit'] = '10';
    // Diabled osm_tag to allow for finding locations based on housenumber
    //    params['osm_tag'] = 'highway';

    return params;
  }

  addressAutocomplete(q: string, lat: number, lng: number): Observable<any> {
    const options = { params: new HttpParams({ fromObject: this.getAddressAutocompleteParams(q, lat, lng) }) };
    return this.http.get<any>(this.config.getPhotonServiceUrl(), options);
  }

  findRoute(start, destination) {
    let params = new HttpParams();

    // const browserLang = this.translater.currentLang;
    // if (browserLang == 'NLD' || browserLang == 'nl' || browserLang == 'nl-be' ) {
    //   params = params.append('lang', 'nl');
    // } else {
    //   params = params.append('lang', 'en');
    // }

    // if ( lat ) {
    //   params = params.append('lat', lat.toString());
    // }

    // if ( lng ) {
    //   params = params.append('lon', lng.toString());
    // }

    // params = params.append('osm_tag', 'highway');

    return this.http.get<any>(this.config.getOsrmRouteUrl(), { params });
  }

}
